import React from 'react'
import { FormattedMessage } from 'react-intl'
import PageTitle from '../PageTitle'
import { InputLabel, Paper } from '@material-ui/core'
import { FormLoader } from '../Loader/FormLoader'
import { SubmissionViewConsumer } from '../../context/SubmissionViewContext'
import { getStatusIcon } from '../../utils/helpers'
import submissionStatus from '../../configurations/submission-status'
import EventIcon from '@material-ui/icons/Event'
import ScheduleIcon from '@material-ui/icons/Schedule'
import 'moment/locale/ar-sa'
import Moment from 'react-moment'
import { singleInvoiceStyles } from '../SingleInvoicePageContent/Styles'
import { InvoicesListingConsumer, InvoicesListingProvider } from '../../context/InvoicesListingContext'
import TableWithFilter from '../InvoicesHelpers/TableWithFilter'
import { AuthConsumer } from '../../context/AuthContext'

const SingleSubmissionPageContent = ({ locale, isMs }) => {

  const invoiceClasses = singleInvoiceStyles()
  const getColumnValue = (key, value, submissionMSId) => {
    if (!!key) {
      switch (key) {
        case 'dateTimeReceived':
          return <div className={invoiceClasses.dateContainer}>
            <div className={'date'}>
              <strong><EventIcon/><Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                                          format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
              <strong><ScheduleIcon/><Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                                             format="hh:mm A">{value}</Moment></strong>
              <span><FormattedMessage id={'Cairo'}/></span>
            </div>
            <div className={'utc'}>
              ( <Moment locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                        format={locale === 'ar' ? 'YYYY/MM/DD ، hh:mm A ' : 'DD/MM/YYYY hh:mm A'} utc>{value}</Moment>
              <span><FormattedMessage id={'UTC'}/></span> )
            </div>
          </div>
        case 'overallStatus':
          let statusArr = !!value && submissionStatus?.length ? submissionStatus.filter((item) => item.key.toString().toLowerCase() === value?.toString()?.toLowerCase()) : []
          return <div className={invoiceClasses.invoiceStatusValueWrapper}>
            <div
              className={invoiceClasses.invoiceStatusContainer + ` ${value?.toString()?.toLowerCase()}`}>
              {getStatusIcon(value, true)}
              <span>{!!statusArr?.length ? statusArr[0][`name_${locale}`] : (value || '')}</span>
            </div>
          </div>

        case 'submissionid':
          return <>
            <div className={'uuid-wrapper'}>{!!submissionMSId && <span><FormattedMessage id={`Fields.view.label.uuid.submissionid`}/>:</span>}<strong>{value}</strong></div>
            {!!submissionMSId && <div className={'uuid-wrapper'}><span><FormattedMessage id={`Fields.view.label.uuid.submissionMSId`}/>:</span><strong>{submissionMSId}</strong></div>}
            </>
        default:
          return <strong>{value}</strong>
      }
    } else {
      return ''
    }
  }
  return (
    <SubmissionViewConsumer>
      {({
          id, submissionData, submissionDataLoading, getSubmissionData, listingCount,
          listingPage, listingRowsPerPage, handleChangeListingPage, handleChangeListingRowsPerPage
        }) => {
        return (
          <>
            <PageTitle
              title={<FormattedMessage id='SingleSubmissionPageContent' values={{
                uuid: id,
                span: chunk => <span>{chunk}</span>
              }}/>}
              invoice
              singleInvoice
            />
            {!!submissionDataLoading && <FormLoader loading={true}/>}
            <Paper elevation={0} className={invoiceClasses.invoiceGeneralDataWrapper}>
              <div className={invoiceClasses.invoiceDatesWrapper + ' submission'}>
                {['submissionid', 'overallStatus', 'documentCount', 'dateTimeReceived'].map((column, index) => (
                  !!submissionData[column] &&
                  <div className={invoiceClasses.printableDataItem} key={index}>
                    <InputLabel><FormattedMessage
                      id={`Fields.view.label.${column}`}/>:</InputLabel>
                    <div className={'info-data'}>
                      {getColumnValue(column, submissionData[column], column === 'submissionid' ? submissionData['submissionMSId'] : null)}
                    </div>
                  </div>
                ))}
              </div>
            </Paper>

            <AuthConsumer>
              {({ taxpayerSubscriptionsData }) => (
                <InvoicesListingProvider list={true} listArr={submissionData?.documentSummary || []}
                                         loadListExternal={getSubmissionData}
                                         hasSubscription={!!taxpayerSubscriptionsData?.hasValidSubscription}>
                  <AuthConsumer>
                    {({ taxpayerData, userPermissions }) => (
                      <InvoicesListingConsumer>
                        {({ listingData }) => (
                          <div className={'listing-wrapper'}>
                            <TableWithFilter
                              listingData={listingData}
                              listingCount={listingCount}
                              listingRowsPerPage={listingRowsPerPage}
                              listingPage={listingPage}
                              handleChangeListingPage={handleChangeListingPage}
                              handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
                              taxpayerData={taxpayerData}
                              locale={locale}
                              userPermissions={userPermissions}
                              noFilter
                              noTypeFilter
                              tabEntityName={isMs ? 'eInvoice' : 'sp'}
                            />
                          </div>
                        )}
                      </InvoicesListingConsumer>
                    )}
                  </AuthConsumer>
                </InvoicesListingProvider>
              )}
            </AuthConsumer>

          </>
        )
      }}
    </SubmissionViewConsumer>
  )
}

export default SingleSubmissionPageContent
